import { type FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface SponsorBannerProps {
  variant?: 'association' | 'brand-strip';
  className?: string;
}

const SPORTBET_LOGO_SRC = '/sponsors/Dream Team Shield.svg';
const BRAND_STRIP_LOGO_COUNT = 6;

const SportbetAssetLogo: FC<{ className?: string }> = ({ className }) => (
  <span
    className={twMerge(
      'inline-flex h-[24px] shrink-0 items-center justify-center',
      'md:h-[30px]',
      className
    )}
    aria-hidden
  >
    <img src={SPORTBET_LOGO_SRC} alt="" className="h-full w-auto object-contain" />
  </span>
);

export const SponsorBanner: FC<SponsorBannerProps> = ({ variant = 'association', className }) => {
  if (variant === 'brand-strip') {
    return (
      <section
        className={twMerge(
          'flex h-[34px] items-center justify-center overflow-hidden',
          'bg-[linear-gradient(to_right,#6aa48e_0%,#456864_16%,#34404c_25%,#20203a_33%,#20203a_67%,#34404c_75%,#456864_84%,#6aa48e_100%)]',
          'md:h-[44px]',
          className
        )}
        aria-label="Sportbet sponsor banner"
      >
        <div className="flex min-w-full w-max items-center justify-center gap-[10%]">
          {Array.from({ length: BRAND_STRIP_LOGO_COUNT }, (_, index) => (
            <SportbetAssetLogo key={index} className="h-[18px] md:h-[22px]" />
          ))}
        </div>
      </section>
    );
  }

  return null;
  return (
    <section
      className={twMerge(
        'flex min-h-[44px] items-center justify-center bg-[ #FF4C4D] px-[16px] py-[8px]',
        className
      )}
      aria-label="In association with Sportbet"
    >
      <div className="flex items-center gap-[10px]">
        <span className="text-[14px] font-bold leading-[18px] text-white md:text-[16px] md:leading-[20px]">
          In association with
        </span>
        <SportbetAssetLogo className="h-[18px] md:h-[22px]" />
      </div>
    </section>
  );
};
